import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ReactCodeInput from 'react-verification-code-input';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import { InputAdornment, IconButton } from '@mui/material';
import { isEmpty, isEqual } from 'lodash';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PropTypes from 'prop-types';

const AuthForm = ({ fields, link, handleClickSubmit, submitTxt }) => {
  const {
    handleSubmit,
    watch,
    getValues,
    register,
    clearErrors,
    setError,
    setValue,
    formState: { errors }
  } = useForm();

  const [submitedValues, setSubmitedValues] = useState({});

  const onSubmit = (data) => {
    if (errors.apiError) {
      clearErrors('apiError');
    }
    setSubmitedValues(data);
    if (isEmpty(errors)) {
      handleClickSubmit(data, setError);
    }
  };

  useEffect(() => {
    if (!isEqual(submitedValues, getValues()))
      if (errors.apiError) {
        clearErrors();
      }
  }, [getValues()]);

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  return (
    <form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
      <div className="wrapper-inputs">
        {fields.map((field) =>
          (() => {
            switch (field?.name) {
              case 'email':
                return (
                  <div className="wrapper-input">
                    <InputLabel classes={{ root: 'rootLabel' }}>
                      אימייל
                    </InputLabel>
                    <TextField
                      fullWidth
                      required
                      classes={{ root: 'rootInput' }}
                      {...register(field.name, {
                        required: true,
                        pattern: field.pattern
                      })}
                      placeholder={field.placeholder}
                    />
                    {errors.email && (
                      <p className="err-msg">{errors.email.message}</p>
                    )}
                  </div>
                );
              case 'password':
                return (
                  <div className="wrapper-input">
                    <InputLabel classes={{ root: 'rootLabel' }}>
                      {field.label}
                    </InputLabel>
                    <TextField
                      fullWidth
                      type={showPassword ? 'text' : 'password'}
                      classes={{ root: 'rootInput' }}
                      placeholder={field.placeholder}
                      {...register(field.name, {
                        required: true,
                        pattern: field.pattern
                      })}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {errors.password && (
                      <p className="err-msg">{errors.password.message}</p>
                    )}
                  </div>
                );
              case 'confirmPassword':
                return (
                  <div className="wrapper-input">
                    <InputLabel classes={{ root: 'rootLabel' }}>
                      {field.label}
                    </InputLabel>
                    <TextField
                      fullWidth
                      type={showPassword ? 'text' : 'password'}
                      classes={{ root: 'rootInput' }}
                      placeholder={field.placeholder}
                      {...register(field.name, {
                        required: true,
                        pattern: field.pattern,
                        validate: (val) => {
                          if (watch('password') != val) {
                            return field.errMsg;
                          }
                        }
                      })}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {errors.confirmPassword && (
                      <p className="err-msg">
                        {errors.confirmPassword.message}
                      </p>
                    )}
                  </div>
                );

              case 'otp':
                return (
                  <div className="wrapper-input">
                    {' '}
                    <div className="code-label">{field.label}</div>
                    <ReactCodeInput
                      {...register(field.name, {
                        required: true
                      })}
                      values={field.defaultValue}
                      placeholder={''}
                      className={`code ${!isEmpty(errors) ? 'error' : ''}`}
                      onChange={(newValue) => {
                        setValue(field.name, newValue);
                      }}
                    ></ReactCodeInput>
                    {errors[field.name] && (
                      <p className="err-msg">{field.errMsg}</p>
                    )}
                  </div>
                );
              default:
                return 'not found';
            }
          })()
        )}
      </div>
      {errors['apiError'] && (
        <p className="err-msg">{errors['apiError'].message}</p>
      )}
      {link && (
        <div className="auth-link">
          {link?.href ? (
            <a href={link?.href}>{link?.text}</a>
          ) : (
            !link?.hidden && (
              <div className="auth-link-div" onClick={link?.handleClickLink}>
                {link?.text}
              </div>
            )
          )}
        </div>
      )}
      <Button
        classes={{ root: 'submit-btn' }}
        variant="contained"
        disableElevation
        // onClick={handleSubmit(onSubmit)}
        type='submit'
        isGreen={true}
      >
        {submitTxt || 'כניסה'}
      </Button>
    </form>
  );
};

export default AuthForm;

AuthForm.propTypes = {
  fields: PropTypes.array,
  link: PropTypes.string,
  handleClickSubmit: PropTypes.func,
  submitTxt: PropTypes.string
};
